export default __webpack_public_path__ + "static/wsl-k3d-start-b8962e7af86810ac09703171f92100bf.webp";